<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-5"
      app
      flat
    >
      <a
        target="_blank"
      >
        <v-img
          v-if="invoice"
          class="mt-4"
          height="100"
          :src="(invoice.self.logo ? invoice.self.logo.link : null)"
          contain
        />
      </a>
      <v-spacer />
    </v-app-bar>
    <v-main>
      <v-container>
        <v-card
          class="mx-auto justify-center mb-1"
          max-width="500"
          style="margin-top: 30px "
          :elevation="(isMobile ? 0 : 10)"
          :flat="isMobile"
        >
          <v-card-title
            v-if="invoice"
            class="justify-center mx-auto pt-3  my-4"
            grey
            darken-3
          >
            {{ invoice.self.abrName }}
          </v-card-title>
          <v-row
            align="center"
            :class="{'mx-0' : !isMobile}"
            no-gutters
          >
            <v-col class="pt-3">
              <v-img
                class="mx-auto"
                height="200"
                contain
                src="@/assets/payment_income.jpg"
              />
            </v-col>
          </v-row>
          <v-row :class="{'mx-0' : !isMobile}">
            <v-btn
              v-if="invoice"
              class="ma-1 px-3"
              color="primary"
              text
              large
              block
            >
              {{ (invoice.type == 'income' ? $t('invoice') : $t(invoice.type)) }} #{{ invoice.uid }}
            </v-btn>
            <v-card-text
              v-if="invoice"
              class="mx-auto align-center pb-1"
            >
              <p class="text-center">
                {{ $t('title') }} : {{ invoice.account.name }}
              </p>
              <p class="text-center">
                {{ $t('customer-name') }} : {{ invoice.customer.name }}
              </p>
              <p class="text-center">
                {{ $t('date') }} : {{ invoice.date }}
              </p>
              <p class="text-center">
                {{ $t('amount') }} : {{ $numberFormat(invoice.price) }} {{ invoice.currency.name }}
              </p>
              <p
                v-if="invoice.content"
                class="text-center"
              >
                {{ $t('content') }} : {{ invoice.content }}
              </p>
            </v-card-text>
            <v-card-text
              v-if="invoice && invoice.type == 'income' && invoice.payed && invoice.payed.amount < invoice.price || invoice && invoice.type == 'income' && !invoice.payed"
              class="mx-auto align-center pb-1"
            >
              <p class="text-center green--text">
                {{ $t('selectGateway') }}
              </p>
            </v-card-text>
            <v-col
              v-if="invoice && invoice.type == 'income' && invoice.payed && invoice.payed.amount < invoice.price || invoice && invoice.type == 'income' && !invoice.payed"
              class="px-4  justify-center xs pb-4 pt-0"
              cols="12"
            >
              <v-chip-group
                v-model="gateway"
                class="justify-center"
                active-class="green--text"
              >
                <v-chip
                  v-if="invoice.self.zibal"
                  value="paymentZibalSystem"
                  filter
                >
                  <v-img
                    max-height="20"
                    max-width="70"
                    src="@/assets/zibal.svg"
                  ></v-img>
                </v-chip>
                <v-chip
                  v-if="invoice.self.zarinpal"
                  filter
                  value="paymentZarinpalSystem"
                >
                  <v-img
                    max-height="20"
                    max-width="70"
                    src="@/assets/zarinpal.svg"
                  ></v-img>
                </v-chip>
              </v-chip-group>
            </v-col>
            <v-col
              v-if="invoice && invoice.type == 'income' && invoice.payed && invoice.payed.amount < invoice.price || invoice && invoice.type == 'income' && !invoice.payed"
              class="px-4  xs py-0"
              cols="12"
            >
              <v-btn
                :disabled="!gateway"
                v-shortkey="['enter']"
                :loading="loading"
                block
                color="green"
                @shortkey="payment"
                @click="payment"
              >
                {{ $t('payment') }}
                <v-icon
                  right
                  dark
                >
                  mdi-keyboard_return
                </v-icon>
              </v-btn>
            </v-col>
            <v-col
              v-if="invoice && invoice.payed && invoice.payed.amount >= invoice.price"
              class="px-8 xs py-0"
              cols="12"
            >
              <v-btn
                block
                color="green"
                outlined
              >
                {{ $t('cleared') }}
              </v-btn>
            </v-col>
            <div
              v-if="invoice"
              align="center"
              style="width: 100%"
              class="py-0 px-4 pt-3 "
            >
              <telegram-button
                :url="'https://abr.abriron.com/pi/' + invoice.uid"
                btn-text=""
                :has-icon="true"
                :description="$t('invoice')"
                class="me-4"
              />
              <whatsapp-button
                :url="'https://abr.abriron.com/pi/' + invoice.uid"
                btn-text=""
                :has-icon="true"
              />
            </div>
            <v-col cols="12" />
          </v-row>
        </v-card>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;position: fixed;background-color: #fff"
      app
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import store from '../../../../store'
  import WhatsappButton from 'vue-share-buttons/src/components/WhatsAppButton'
  import TelegramButton from 'vue-share-buttons/src/components/TelegramButton'
  export default {
    components: {
      Snakbar,
      WhatsappButton,
      TelegramButton,
    },
    mixins: [General],
    props: ['lang', 'phone', 'password', 'shop'],
    data () {
      return {
        has_error: false,
        text_error: null,
        loading: false,
        gateway: null,
        id: null,
        currency: null,
        currency_amount: null,
        currencyName: null,
        number: null,
        invoice: null,
      }
    },
    beforeMount () {
      if (this.$route.params.id) {
        this.id = this.$route.params.id
        this.show()
      }
    },
    mounted () {
    },
    methods: {
      show () {
        var app = this
        app.loading = true
        app.$axios.get(this.$apipoint + 'print/income/' + this.id, {
          params: {
            id: this.idProp,
            print: 'active',
            cuid: (app.$route.query.cuid ? app.$route.query.cuid : localStorage.getItem('cuid')),
          },
        })
          .then(res => {
            app.$nextTick(() => {
              res = res.data
              app.id = res.id
              app.invoice = res
              store.commit('SET_RTL', res.self.rtl.value)
              store.commit('SET_LANG', res.self.lang.value)
              setTimeout(function () {
                app.render = true
              }, 1000)
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      payment () {
        var app = this
        app.loading = true
        app.$axios.get(this.$apipoint + 'income/payment/' + this.id, {
          params: {
            payment: 'active',
            id: app.invoice.id,
            gateway: app.gateway,
            cuid: (app.$route.query.cuid ? app.$route.query.cuid : localStorage.getItem('cuid')),
          },
        })
          .then(res => {
            res = res.data
            window.location.href = res.action
            // window.open(res.action, '_blank')
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped>

div.v-slide-group__content {
  justify-content: center !important;
}
</style>
